<template>
  <div class="price-guidance-tabs">
    <div class="price-guidance">
      <span class="title fl">价格指导</span>
      <div v-loading="loading">
        <el-tabs
          v-model="activeName1"
          class="el-tabs__customize price-guidance-tabs"
          @tab-click="handleClickOne"
          :lazy="false"
        >
          <el-tab-pane
            v-for="(item, index) in list1"
            :key="index"
            :name="`tab${index}`"
            :label="item.name"
          >
            <span
              class="left-btn"
              @click="moreLeftData(item1)"
              v-if="priceList.length > 0 && pageNo != 1"
            >
              <i class="el-icon-caret-left"></i>
            </span>
            <div
              class="list"
              :id="'echartsContainer' + index"
              style="width: 100%; height: 255px"
            >
              <!-- <div
              
                class="focusNew ccui-clearfix"
                v-for="(item1, index1) in priceList"
                :key="index1"
              >
                <div
                  @mouseenter="showDialog(item1, index, index1, $event)"
                  @mouseleave="hideDialog(item1, index, index1)"
                >
                  <div class="top">
                    {{ item1.title }}
                  </div>
                  <div class="content">
                    <div class="openPrice">
                      开盘价
                      <span
                        class="price"
                        :style="
                          item1.raise >= 1
                            ? 'color: #FF4747;'
                            : item1.raise === 0
                            ? 'color: #0089ef;'
                            : 'color: #2BA571;'
                        "
                      >
                        {{ item1.startPrice }}
                        <i
                          v-if="item1.raise >= 1"
                          style="color: #FF4747;"
                          class="el-icon-top"
                        ></i>
                        <i
                          v-else-if="item1.raise === 0"
                          style="color: #0089ef;"
                        ></i>
                        <i
                          v-else-if="item1.raise < 1"
                          style="color: #2BA571;"
                          class="el-icon-bottom"
                        ></i>
                      </span>
                    </div>
                    <div class="closePrice">
                      较昨日
                      <span
                        class="price"
                        :style="
                          item1.raise >= 1
                            ? 'color: #FF4747;'
                            : item1.raise === 0
                            ? 'color:  #0089ef;'
                            : 'color: #2BA571;'
                        "
                      >
                        <i
                          v-if="item1.raise >= 1"
                          style="color: #FF4747;"
                          class="el-icon-plus"
                        ></i>
                        <i
                          v-else-if="item1.raise === 0"
                          style="color:  #0089ef;"
                        ></i>
                        <i
                          v-else-if="item1.raise < 1"
                          style="color: #2BA571;"
                        ></i>

                        {{ item1.raise === 0 ? "持平" : item1.raise }}
                      </span>
                    </div>
                  </div>
                  <div class="bottom">
                    <div class="address">
                      {{ item1.cpName }}

                      <span style="margin-left: 10px;">{{
                        item1.areaName
                      }}</span>
                    </div>
                    <span class="time">{{
                      item1.publishTime.slice(0, -3)
                    }}</span>
                  </div> -->
              <!-- v-if="hoverIndex === index1" -->
              <!-- <div v-if="hoverIndex === index1" class="dialog">
                    <div class="triangle-down"></div>
                    <div class="ZXtitle">
                      {{ item1.title }}
                    </div>
                    <div class="cpName">
                      {{ item1.cpName }}
                    </div>
                    <div
                      :id="'echartsContainer' + `${index}${index1}`"
                      style="width: 381px; height: 285px;"
                    ></div>
                    <div class="areaName">
                      {{ item1.areaName }}
                    </div>
                  </div>
                </div>
              </div> -->
            </div>

            <span
              class="right-btn"
              @click="moreRightData(item1)"
              v-if="priceList.length > 0 && pageNo != total"
            >
              <i class="el-icon-caret-right"></i>
            </span>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="location-select">
        <!-- <span
          style="transform: translateX(11px);display: inline-block;
    position: relative;pointer-events: none;
    z-index: 100;"
          >按天<i class="el-icon-arrow-down" style="margin-left:5px"></i
        ></span> -->
        <el-select
          v-model="dateType"
          placeholder=""
          class="typeselect"
          @change="dateChange"
          filterable
        >
          <el-option key="0" label="按天" value="0"> </el-option>
          <el-option key="1" label="按周" value="1"> </el-option>
          <el-option key="2" label="按月" value="2"> </el-option>
        </el-select>
        <el-date-picker
          v-model="complierTime"
          searchLabel="编制时间"
          ref="datePicker"
          :picker-options="pickerOptions"
          clearable
          type="daterange"
          @change="chanRange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          slot="searchItem6"
        >
        </el-date-picker>
        <!-- <i class="el-icon-location-outline" style="color: #eb4025"></i> -->
        <el-select
          v-model="matCode"
          placeholder="请选择物资"
          class="matselect"
          @change="matChange"
          filterable
        >
          <el-option
            v-for="item in matCodeOptions"
            :key="item.dicKey"
            :label="item.dicValue"
            :value="item.dicKey"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="addressValue"
          placeholder=""
          @change="addressChange"
          filterable
        >
          <el-option
            v-for="item in addressOptions"
            :key="item.addressCode"
            :label="item.addressName"
            :value="item.addressName"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="addressValueCity"
          placeholder="请选择"
          @change="cityaddressChange"
          filterable
        >
          <el-option
            v-for="item in cityaddressOptions"
            :key="item.addressCode"
            :label="item.addressName"
            :value="item.addressName"
          >
          </el-option>
        </el-select>
      </div>

      <!-- <el-link
        :underline="false"
        type="info"
        class="notice-more"
        @click="handleViewAll(source.marketDynamic)"
      >
        更多 ></el-link
      > -->
    </div>

    <div class="towBox"></div>
  </div>
</template>

<script>
var pickerMinDate = "";
var dateType = "1";
import {
  listDictByDJCode,
  getAiChartData,
  getCementChartData,
  qryAllProvince,
  qryAddressByCodeRegion
} from "@/app/shop/api/shopping";
import * as echarts from "echarts";
import { announcementPageSource } from "@/setting/setting";
var myChart = null;
export default {
  name: "priceGuidance",
  data() {
    return {
      hoverIndex: null,
      tabIndex: "0",
      showChart: false,
      complierTime: "",
      list1: [],
      list2: [],
      list3: [],
      loading: false,
      gangOptions: [],
      matCodeOptions: [],
      shuiniOptions: [],
      priceList: [],
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          // 记录开始选择的日期
          pickerMinDate = minDate.getTime();

          // 如果选择完成（两个日期都选了），清空临时记录
          if (maxDate) {
            pickerMinDate = "";
          }
        },
        disabledDate(time) {
          console.log(dateType);
          // 如果没有基准日期，只禁用未来日期
          if (!pickerMinDate || dateType != "0") {
            return time.getTime() > Date.now();
          }

          const oneMonth = 31 * 24 * 3600 * 1000;
          const minTime = pickerMinDate - oneMonth;
          let maxTime = pickerMinDate + oneMonth;

          // 确保最大时间不超过当前时间
          maxTime = Math.min(maxTime, Date.now());

          // 禁用范围外的日期
          return time.getTime() < minTime || time.getTime() > maxTime;
        }
      },
      addressOptions: [],
      cityaddressOptions: [],
      data: [10, 20, 30, 40, 50],
      // addressValueCity: "市辖区",
      addressValueCity: "",
      addressValue: "上海市",
      matCode: "",
      dateType: "1",
      addressCode: "", // 省份编码
      childrenList2: [],
      activeName1: "tab0",
      activeName2: "tab0",
      source: announcementPageSource,
      marketDynamicUrl: "",
      priceInfoUrl: "",
      pageNo: 1,
      total: 0,
      interfaceType: "4" // 获取市场动态下的：分析报告、市场详情、行业要闻  默认是：分析报告
    };
  },
  computed: {},
  watch: {
    dateType(val) {
      dateType = val;
    }
  },
  mounted() {
    this.complierTime = [
      this.format(new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000)),
      this.format(new Date())
    ]; // 当前日期和前30天
  },
  activated() {
    this.list1 = [
      {
        code: "00000000019",
        name: "钢筋",
        shortName: ""
      },
      {
        code: "00001293881",
        name: "水泥",
        shortName: ""
      }
    ];
    this.init("00000000019", this.pageNo, "");
    //     this.init("9001", this.pageNo, "");
    // selectPortalTypeList({}).then(res => {
    //   if (res.data.code === "0") {
    //     this.list1 = res.data.data;
    //     this.init("9001", this.pageNo, "");
    //   }
    // });
    // this.qryAddressByCodeRegion("上海");
  },
  deactivated() {
    this.list1 = [];
    this.list2 = [];
    this.list3 = [];
    this.priceList = [];
    this.childrenList2 = [];
    this.activeName1 = "tab0";
    this.activeName2 = "tab0";
    this.marketDynamicUrl = "";
    this.priceInfoUrl = "";
  },
  beforeDestroy() {},
  methods: {
    chanRange() {
      if (this.tabIndex == "0") {
        this.showDialog("", "", "", this.matCode);
      } else if (this.tabIndex == "1") {
        this.showDialogShuini("", "", "", this.matCode);
      }
    },
    dateChange() {
      if (this.tabIndex == "0") {
        this.showDialog("", "", "", this.matCode);
      } else if (this.tabIndex == "1") {
        this.showDialogShuini("", "", "", this.matCode);
      }
    },
    format(currentDate) {
      let year = currentDate.getFullYear();
      let month = (currentDate.getMonth() + 1).toString().padStart(2, "0"); // 月份从0开始，需要加1
      let day = currentDate
        .getDate()
        .toString()
        .padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    async init(code, pageNo, type) {
      // getAiChartData({

      // }).then(res=>{

      // })
      // this.loading = true;
      await listDictByDJCode({
        agentId: "100125",
        code: "MAT_CODE_BARS"
      }).then(res => {
        this.matCodeOptions = res.data.data;
        this.gangOptions = res.data.data;
        this.matCode = res.data.data[7].dicKey;
      });
      listDictByDJCode({
        agentId: "100125",
        code: "MAT_CODE_CEMENT"
      }).then(res => {
        this.shuiniOptions = res.data.data;
      });
      qryAllProvince({
        agentId: 100125,
        baseAppId: 100126
      }).then(resOne => {
        if (resOne.data.code === "0") {
          this.addressOptions = resOne.data.data;
          this.addressOptions.forEach(item => {
            if (item.addressName == "上海市") {
              this.addressValue = type ? this.addressValue : item.addressName;
              this.addressChange(item.addressName);
            }
          });
          this.showDialog("", "", "", code);
          // selectPortalInfoList({
          //   areaCode: this.addressValue,
          //   type: code,
          //   name: this.addressValue,
          //   pageNo: pageNo,
          //   pageSize: 8
          // }).then(resTwo => {
          //   if (resTwo.data.code === "0") {
          //     this.priceList = resTwo.data.data.rows;
          //     this.pageNo = resTwo.data.data.pageNo;
          //     this.total = resTwo.data.data.total;
          //     this.loading = false;
          //   }
          // });
        }
      });
    },
    handleViewAll() {
      this.$router.push({
        path: "/announcementsList",
        query: {
          source: "1"
          // interfaceType: "1"
        }
      });
    },
    moreLeftData(item) {
      console.log(this.activeName1, "moreData");
      let codeValue = "";
      if (this.activeName1 == "tab0") {
        codeValue = "9001";
      }
      if (this.activeName1 == "tab1") {
        codeValue = "9002";
      }
      if (this.activeName1 == "tab2") {
        codeValue = "9003";
      }
      if (this.activeName1 == "tab3") {
        codeValue = "9004";
      }
      if (this.activeName1 == "tab4") {
        codeValue = "9005";
      }
      if (this.activeName1 == "tab5") {
        codeValue = "9006";
      }
      this.pageNo = this.pageNo === 1 ? 1 : this.pageNo - 1;
      this.init(codeValue, this.pageNo, "addressChange");
    },
    moreRightData(item) {
      console.log(this.activeName1, "moreData");
      let codeValue = "";
      if (this.activeName1 == "tab0") {
        codeValue = "9001";
      }
      if (this.activeName1 == "tab1") {
        codeValue = "9002";
      }
      if (this.activeName1 == "tab2") {
        codeValue = "9003";
      }
      if (this.activeName1 == "tab3") {
        codeValue = "9004";
      }
      if (this.activeName1 == "tab4") {
        codeValue = "9005";
      }
      if (this.activeName1 == "tab5") {
        codeValue = "9006";
      }
      this.init(codeValue, this.pageNo + 1, "addressChange");
    },
    addressChange(item) {
      this.addressValueCity = "";
      let arr = this.addressOptions.filter(obj => {
        return obj.addressName == item;
      });
      qryAddressByCodeRegion({
        addressCode: arr[0].addressCode, // 省份编码
        agentId: 100125,
        purSupFlag: "pur",
        baseAppId: 100126
      }).then(res => {
        this.cityaddressOptions = res.data.data;
        // this.addressValueCity = this.cityaddressOptions[0].addressName;
        this.cityaddressChange();
      });
      return;
      // let codeValue = "";
      // if (this.activeName1 == "tab0") {
      //   codeValue = "9001";
      // }
      // if (this.activeName1 == "tab1") {
      //   codeValue = "9002";
      // }
      // if (this.activeName1 == "tab2") {
      //   codeValue = "9003";
      // }
      // if (this.activeName1 == "tab3") {
      //   codeValue = "9004";
      // }
      // if (this.activeName1 == "tab4") {
      //   codeValue = "9005";
      // }
      // if (this.activeName1 == "tab5") {
      //   codeValue = "9006";
      // }
      // this.init(codeValue, this.pageNo, "addressChange");
    },
    cityaddressChange() {
      if (this.tabIndex == "0") {
        this.showDialog("", "", "", this.matCode);
      } else if (this.tabIndex == "1") {
        this.showDialogShuini("", "", "", this.matCode);
      }
    },
    matChange() {
      if (this.tabIndex == "0") {
        this.showDialog("", "", "", this.matCode);
      } else if (this.tabIndex == "1") {
        this.showDialogShuini("", "", "", this.matCode);
      }
    },
    handleClickOne(tab) {
      if (tab.index == "0") {
        this.tabIndex = "0";
        this.matCodeOptions = this.gangOptions;
        this.matCode = this.matCodeOptions[7].dicKey;
        this.showDialog();
      }
      if (tab.index == "1") {
        this.tabIndex = "1";
        this.matCodeOptions = this.shuiniOptions;
        this.matCode = this.matCodeOptions[0].dicKey;
        this.showDialogShuini();
      }
    },
    setItemRef(el) {
      if (el) {
        this.itemRefs[el.id] = el;
      }
    },
    showDialog(item, index, index1, code) {
      console.log(this.complierTime);
      if (!this.complierTime) {
        this.$message({
          message: "请选择时间范围查询",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        return;
      }
      var marName = this.matCodeOptions.filter(
        item => item.dicKey == this.matCode
      )[0].dicValue;
      this.loading = true;
      getAiChartData({
        matCode: this.matCode,
        dateType: this.dateType,
        startTime: this.complierTime[0],
        endTime: this.complierTime[1],
        province: this.addressValue,
        city: this.addressValueCity
      })
        .then(res => {
          this.loading = false;
          console.log(
            document.getElementById("echartsContainer" + this.tabIndex),
            "echartsContainer"
          );
          if (myChart) {
            myChart.dispose();
          }
          myChart = echarts.init(
            document.getElementById("echartsContainer" + this.tabIndex)
          );
          res.data.data.purchList.forEach((item, index) => {
            if (item === 0) {
              res.data.data.purchList[index] = undefined;
            }
          });
          res.data.data.bidList.forEach((item, index) => {
            if (item === 0) {
              res.data.data.bidList[index] = undefined;
            }
          });
          res.data.data.settList.forEach((item, index) => {
            if (item === 0) {
              res.data.data.settList[index] = undefined;
            }
          });
          res.data.data.infoList.forEach((item, index) => {
            if (item === 0) {
              res.data.data.infoList[index] = undefined;
            }
          });
          res.data.data.contList.forEach((item, index) => {
            if (item === 0) {
              res.data.data.contList[index] = undefined;
            }
          });
          // let min =
          //     res.data.data.minPrice < res.data.data.priceRangeMin
          //       ? Math.floor(res.data.data.minPrice / 200) * 200
          //       : Math.floor(res.data.data.priceRangeMin / 200) * 200,
          //   max =
          //     res.data.data.maxPrice > res.data.data.priceRangeMax
          //       ? Math.ceil(res.data.data.maxPrice / 200) * 200
          //       : Math.ceil(res.data.data.priceRangeMax / 200) * 200,
          //   inte;
          let min = Math.floor(res.data.data.minPrice / 100) * 100,
            max = Math.ceil(res.data.data.maxPrice / 100) * 100,
            inte;
          if (max - min > 100) {
            inte = Math.floor((max - min) / 10 / 30) * 30;
          } else {
            inte = Math.floor((max - min) / 10);
          }

          console.log(res.data.data.openValueList, "myChart");

          myChart.setOption({
            title: {
              text: marName
            },
            tooltip: {
              trigger: "axis",
              formatter: function(params) {
                // params 是一个数组，包含了触发 tooltip 的所有数据点信息
                // 这里我们取第一个数据点，并添加单位
                var res = params[0].name + "<br/>";
                params.forEach(function(item) {
                  res +=
                    item.seriesName +
                    " : " +
                    (item.value ? item.value : 0) +
                    " 元/吨<br/>";
                });
                return res;
              }
            },
            legend: {
              data: ["信息价格", "集采价格", "中标价格", "合同价格", "结算价格"]
            },
            grid: {
              left: "1%",
              right: "5%",
              bottom: "3%",
              show: false,
              containLabel: true
            },
            // toolbox: {
            //   feature: {
            //     saveAsImage: {}
            //   }
            // },
            xAxis: {
              type: "category",
              axisTick: {
                show: false // 确保刻度线显示
              },
              boundaryGap: false,
              data: res.data.data.dateList,
              splitLine: {
                show: false, // 是否显示分割线，默认数值轴显示，类目轴不显示
                lineStyle: {
                  color: "#D3F2F5", // 分割线颜色
                  type: "solid" // 分割线类型
                }
              },
              axisLabel: {
                show: true,
                interval: 0,
                formatter: val => (this.dateType == "0" ? val.slice(8) : val),
                textStyle: {
                  color: "#4A4A4A",
                  fontSize: "13px"
                }
              },
              axisLine: {
                show: true, // 控制Y轴线是否显示
                lineStyle: {
                  color: "#DFDFDF" // 轴线颜色
                }
              }
            },
            yAxis: {
              type: "value",
              boundaryGap: false,
              // interval: 30,
              axisTick: {
                show: false // 确保刻度线显示
              },
              interval: inte,
              min: Math.floor(res.data.data.minPrice / 100) * 100,
              max: Math.ceil(res.data.data.maxPrice / 100) * 100,
              name: res.data.data.cpName,
              splitLine: {
                show: true, // 是否显示分割线，默认数值轴显示，类目轴不显示
                lineStyle: {
                  color: "#D3F2F5", // 分割线颜色
                  type: "solid" // 分割线类型
                }
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: "#4A4A4A",
                  fontSize: "13px"
                }
              },
              axisLine: {
                show: true, // 控制Y轴线是否显示

                lineStyle: {
                  color: "#DFDFDF", // Y轴线颜色
                  // width: 2, // Y轴线宽度
                  type: "solid" // Y轴线类型
                }
              }
            },
            series: [
              {
                name: "信息价格",
                type: "line",
                // connectNulls: true, // 添加这一行，强制连接空数据
                // stack: "Total",
                smoothMonotone: "x",
                symbol: "circle", // 设置折线图中的标记形状为圆形
                symbolSize: 3, // 设置折线图中的标记大小
                showSymbol: false,
                lineStyle: {
                  width: 3 // 设置线条宽度
                },
                color: "#FF2121",
                data: res.data.data.infoList,
                markLine: {
                  data: [
                    { yAxis: res.data.data.priceRangeMax },
                    {
                      yAxis: res.data.data.priceRangeMin,
                      lineStyle: {
                        type: "dashed",
                        color: "#F78948 ",
                        width: 1
                      }
                    }
                  ],
                  lineStyle: {
                    type: "dashed",
                    color: "#F78948 ",
                    width: 1
                  },
                  showSymbol: false, // 不显示数据点标记
                  symbol: "none" // 不使用任何标记形状
                },
                smooth: true
              },
              {
                name: "集采价格",
                type: "line",
                // connectNulls: true, // 添加这一行，强制连接空数据
                // stack: "Total",
                showSymbol: false,
                symbol: "circle", // 设置折线图中的标记形状为圆形
                symbolSize: 3, // 设置折线图中的标记大小
                smoothMonotone: "x",
                lineStyle: {
                  width: 3 // 设置线条宽度
                },
                color: "#DF31FF ",
                data: res.data.data.purchList,
                smooth: true
              },
              {
                name: "中标价格",
                symbol: "circle", // 设置折线图中的标记形状为圆形
                symbolSize: 3, // 设置折线图中的标记大小
                type: "line",
                // connectNulls: true, // 添加这一行，强制连接空数据
                // stack: "Total",
                showSymbol: this.dateType == "1" ? true : false,
                smoothMonotone: "x",
                lineStyle: {
                  width: 3 // 设置线条宽度
                },
                color: "#6BFF98 ",
                data: res.data.data.bidList,
                smooth: true
              },
              {
                name: "合同价格",
                symbol: "circle", // 设置折线图中的标记形状为圆形
                symbolSize: 3, // 设置折线图中的标记大小
                type: "line",
                // connectNulls: true, // 添加这一行，强制连接空数据
                // stack: "Total",
                showSymbol: this.dateType == "1" ? true : false,
                smoothMonotone: "x",
                lineStyle: {
                  width: 3 // 设置线条宽度
                },
                color: "#93C2FF",
                data: res.data.data.contList,
                smooth: true
              },
              {
                name: "结算价格",
                type: "line",
                // connectNulls: true, // 添加这一行，强制连接空数据
                // stack: "Total",
                symbol: "circle", // 设置折线图中的标记形状为圆形
                symbolSize: 3, // 设置折线图中的标记大小
                showSymbol: this.dateType == "1" ? true : false,
                smoothMonotone: "x",
                lineStyle: {
                  width: 3 // 设置线条宽度
                },
                color: "#FFA123",
                data: res.data.data.settList,
                smooth: true
              }
            ]
          });
          var option = myChart.getOption();
          myChart.off("legendselectchanged", legendSelectHandler);
          function legendSelectHandler(evt) {
            var selected = evt.selected; // 获取当前图例选中状态的对象
            var range = [];
            option.series.forEach(function(series, index) {
              series.show = selected[option.legend[0].data[index]]; // 根据图例状态更新 series 的 show 属性
            });
            Object.keys(selected).forEach(key => {
              if (selected[key]) {
                switch (key) {
                  case "信息价格":
                    range.push(res.data.data.maxInfoPrice);
                    range.push(res.data.data.minInfoPrice);
                    break;
                  case "集采价格":
                    range.push(res.data.data.maxPurPrice);
                    range.push(res.data.data.minPurPrice);
                    break;
                  case "中标价格":
                    range.push(res.data.data.maxBidPrice);
                    range.push(res.data.data.minBidPrice);
                    break;
                  case "合同价格":
                    range.push(res.data.data.minContPrice);
                    range.push(res.data.data.maxContPrice);
                    break;
                  default:
                    range.push(res.data.data.maxSettPrice);
                    range.push(res.data.data.minSettPrice);
                    break;
                }
              }
            });
            range = range.filter(item => item !== 0);
            let min = Math.min(...range);
            let max = Math.max(...range);
            option.yAxis[0].max = Math.ceil(max / 100) * 100;
            option.yAxis[0].min = Math.floor(min / 100) * 100;
            myChart.setOption(option); // 应用更新
          }
          myChart.on("legendselectchanged", legendSelectHandler);
        })
        .catch(res => {
          this.loading = false;
        });
    },
    showDialogShuini(item, index, index1, code) {
      console.log(this.complierTime);
      if (!this.complierTime) {
        this.$message({
          message: "请选择时间范围查询",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        return;
      }
      var marName = this.matCodeOptions.filter(
        item => item.dicKey == this.matCode
      )[0].dicValue;
      this.loading = true;
      getCementChartData({
        matCode: this.matCode,
        dateType: this.dateType,
        startTime: this.complierTime[0],
        endTime: this.complierTime[1],
        province: this.addressValue,
        city: this.addressValueCity
      })
        .then(res => {
          this.loading = false;
          console.log(
            document.getElementById("echartsContainer" + this.tabIndex),
            "echartsContainer"
          );
          if (myChart) {
            myChart.dispose();
          }
          myChart = echarts.init(
            document.getElementById("echartsContainer" + this.tabIndex)
          );
          res.data.data.bidList.forEach((item, index) => {
            if (item === 0) {
              res.data.data.bidList[index] = undefined;
            }
          });
          res.data.data.settList.forEach((item, index) => {
            if (item === 0) {
              res.data.data.settList[index] = undefined;
            }
          });
          res.data.data.infoList.forEach((item, index) => {
            if (item === 0) {
              res.data.data.infoList[index] = undefined;
            }
          });
          res.data.data.contList.forEach((item, index) => {
            if (item === 0) {
              res.data.data.contList[index] = undefined;
            }
          });
          // let min =
          //     res.data.data.minPrice < res.data.data.priceRangeMin
          //       ? Math.floor(res.data.data.minPrice / 200) * 200
          //       : Math.floor(res.data.data.priceRangeMin / 200) * 200,
          //   max =
          //     res.data.data.maxPrice > res.data.data.priceRangeMax
          //       ? Math.ceil(res.data.data.maxPrice / 200) * 200
          //       : Math.ceil(res.data.data.priceRangeMax / 200) * 200,
          //   inte;
          let min = Math.floor(res.data.data.minPrice / 100) * 100,
            max = Math.ceil(res.data.data.maxPrice / 100) * 100,
            inte;
          if (max - min > 100) {
            inte = Math.floor((max - min) / 10 / 30) * 30;

            if (max - min < 500) {
              inte = Math.ceil((max - min) / 5 / 10) * 10;
            }
          } else {
            inte = Math.floor((max - min) / 10);
          }

          console.log(res.data.data.openValueList, "myChart");

          myChart.setOption({
            title: {
              text: marName
            },
            tooltip: {
              trigger: "axis",
              formatter: function(params) {
                // params 是一个数组，包含了触发 tooltip 的所有数据点信息
                // 这里我们取第一个数据点，并添加单位
                var res = params[0].name + "<br/>";
                params.forEach(function(item) {
                  res +=
                    item.seriesName +
                    " : " +
                    (item.value ? item.value : 0) +
                    " 元/吨<br/>";
                });
                return res;
              }
            },
            legend: {
              data: ["中标价格", "合同价格", "结算价格", "信息价格"]
            },
            grid: {
              left: "3%",
              right: "5%",
              bottom: "3%",
              show: false,
              containLabel: true
            },
            // toolbox: {
            //   feature: {
            //     saveAsImage: {}
            //   }
            // },
            xAxis: {
              type: "category",
              axisTick: {
                show: false // 确保刻度线显示
              },
              boundaryGap: false,
              data: res.data.data.dateList,
              splitLine: {
                show: false, // 是否显示分割线，默认数值轴显示，类目轴不显示
                lineStyle: {
                  color: "#D3F2F5", // 分割线颜色
                  type: "solid" // 分割线类型
                }
              },
              axisLabel: {
                show: true,
                interval: 0,
                formatter: val => (this.dateType == "0" ? val.slice(8) : val),
                textStyle: {
                  color: "#4A4A4A",
                  fontSize: "13px"
                }
              },
              axisLine: {
                show: true, // 控制Y轴线是否显示
                lineStyle: {
                  color: "#DFDFDF" // 轴线颜色
                }
              }
            },
            yAxis: {
              type: "value",
              boundaryGap: false,
              // interval: 30,
              axisTick: {
                show: true // 确保刻度线显示
              },
              interval: inte,
              min: Math.floor(res.data.data.minPrice / 100) * 100,
              max: Math.ceil(res.data.data.maxPrice / 100) * 100,
              name: res.data.data.cpName,
              splitLine: {
                show: true, // 是否显示分割线，默认数值轴显示，类目轴不显示
                lineStyle: {
                  color: "#D3F2F5", // 分割线颜色
                  type: "solid" // 分割线类型
                }
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: "#4A4A4A",
                  fontSize: "13px"
                }
              },
              axisLine: {
                show: true, // 控制Y轴线是否显示

                lineStyle: {
                  color: "#DFDFDF", // Y轴线颜色
                  // width: 2, // Y轴线宽度
                  type: "solid" // Y轴线类型
                }
              }
            },
            series: [
              {
                name: "中标价格",
                symbol: "circle", // 设置折线图中的标记形状为圆形
                symbolSize: 3, // 设置折线图中的标记大小
                type: "line",
                // connectNulls: true, // 添加这一行，强制连接空数据
                // stack: "Total",
                showSymbol: this.dateType == "1" ? true : false,
                smoothMonotone: "x",
                lineStyle: {
                  width: 3 // 设置线条宽度
                },
                color: "#6BFF98 ",
                data: res.data.data.bidList,
                smooth: true
              },
              {
                name: "合同价格",
                symbol: "circle", // 设置折线图中的标记形状为圆形
                symbolSize: 3, // 设置折线图中的标记大小
                type: "line",
                // connectNulls: true, // 添加这一行，强制连接空数据
                // stack: "Total",
                showSymbol: this.dateType == "1" ? true : false,
                smoothMonotone: "x",
                lineStyle: {
                  width: 3 // 设置线条宽度
                },
                color: "#93C2FF",
                data: res.data.data.contList,
                smooth: true
              },
              {
                name: "结算价格",
                type: "line",
                // connectNulls: true, // 添加这一行，强制连接空数据
                // stack: "Total",
                symbol: "circle", // 设置折线图中的标记形状为圆形
                symbolSize: 3, // 设置折线图中的标记大小
                showSymbol: this.dateType == "1" ? true : false,
                smoothMonotone: "x",
                lineStyle: {
                  width: 3 // 设置线条宽度
                },
                color: "#FFA123",
                data: res.data.data.settList,
                smooth: true
              },
              {
                name: "信息价格",
                type: "line",
                // connectNulls: true, // 添加这一行，强制连接空数据
                // stack: "Total",
                smoothMonotone: "x",
                symbol: "circle", // 设置折线图中的标记形状为圆形
                symbolSize: 3, // 设置折线图中的标记大小
                showSymbol: false,
                lineStyle: {
                  width: 3 // 设置线条宽度
                },
                color: "#FF2121",
                data: res.data.data.infoList,
                markLine: {
                  data: [
                    { yAxis: res.data.data.priceRangeMax },
                    {
                      yAxis: res.data.data.priceRangeMin,
                      lineStyle: {
                        type: "dashed",
                        color: "#F78948 ",
                        width: 1
                      }
                    }
                  ],
                  lineStyle: {
                    type: "dashed",
                    color: "#F78948 ",
                    width: 1
                  },
                  showSymbol: false, // 不显示数据点标记
                  symbol: "none" // 不使用任何标记形状
                },
                smooth: true
              }
            ]
          });
          var option = myChart.getOption();
          myChart.off("legendselectchanged", legendSelectHandler);
          function legendSelectHandler(evt) {
            var selected = evt.selected; // 获取当前图例选中状态的对象
            var range = [];
            option.series.forEach(function(series, index) {
              series.show = selected[option.legend[0].data[index]]; // 根据图例状态更新 series 的 show 属性
            });
            Object.keys(selected).forEach(key => {
              if (selected[key]) {
                switch (key) {
                  case "信息价格":
                    range.push(res.data.data.maxInfoPrice);
                    range.push(res.data.data.minInfoPrice);
                    break;
                  case "中标价格":
                    range.push(res.data.data.maxBidPrice);
                    range.push(res.data.data.minBidPrice);
                    break;
                  case "合同价格":
                    range.push(res.data.data.minContPrice);
                    range.push(res.data.data.maxContPrice);
                    break;
                  default:
                    range.push(res.data.data.maxSettPrice);
                    range.push(res.data.data.minSettPrice);
                    break;
                }
              }
            });
            range = range.filter(item => item !== 0);
            let min = Math.min(...range);
            let max = Math.max(...range);
            option.yAxis[0].max = Math.ceil(max / 100) * 100;
            option.yAxis[0].min = Math.floor(min / 100) * 100;
            myChart.setOption(option); // 应用更新
          }
          myChart.on("legendselectchanged", legendSelectHandler);
        })
        .catch(res => {
          this.loading = false;
        });
    },
    hideDialog(item, index, index1) {
      var element = document.getElementById("echartsContainer");
      element.remove();
    }
  }
};
</script>

<style scoped lang="scss">
.dataNull {
  text-align: center;
  color: #909399;
  font-size: 13px;
  margin-top: 60px;
}
/deep/ .el-tabs__content {
  overflow: visible !important;
}
.dialog {
  // display: none;
  position: relative;
  width: 381px;
  height: 300px;
  background-color: #fff;
  box-shadow: 5px 5px 13px 1px rgba(0, 0, 0, 0.3);
  padding: 10px;
  z-index: 10;
  text-align: left;
  right: 50%;
  .areaName {
    position: absolute;
    top: 50px;
    right: 23px;
  }
  .cpName {
    position: absolute;
    top: 50px;
    left: 23px;
  }
  .triangle-down {
    position: absolute;
    top: -9px;
    right: 50%;
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 9px solid #fff;
  }
  .ZXtitle {
    font-weight: 600;
    font-size: 14px;
    color: #4a4a4a;
    line-height: 20px;
    text-align: center;
  }
}

li:hover .dialog {
  display: block;
}
.price-guidance-tabs {
  position: relative;

  .left-btn {
    position: absolute;
    top: 37%;
    left: -20px;
    width: 18px;
    height: 40px;
    line-height: 45px;
    text-align: center;
    background: #9c9c9c;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    .el-icon-caret-left {
      color: #ebebeb;
      font-size: 18px;
    }
    &:hover {
      cursor: pointer;
      background: #0089ef;
    }
  }
  .right-btn {
    position: absolute;
    top: 37%;
    right: 0px;
    width: 18px;
    height: 40px;
    line-height: 45px;
    background: #9c9c9c;
    text-align: center;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    .el-icon-caret-right {
      color: #ebebeb;
      font-size: 18px;
    }
    &:hover {
      cursor: pointer;
      background: #0089ef;
    }
  }
}
.price-guidance {
  position: relative;
  width: 1160px;
  height: 300px;
  margin-top: 20px;
  background: #ffffff;
  padding: 12px 0px 11px 20px;
  .title {
    font-weight: 600;
    font-size: 20px;
    color: #4a4a4a;
    line-height: 28px;
    text-align: left;
    margin-right: 20px;
  }
  .list {
    display: flex;
    flex-wrap: wrap;
    .focusNew {
      width: 242px;
      height: 86px;
      background: #f3f7ff;
      margin: 0 20px 12px 0;
      padding: 7px 14px;
      border-radius: 6px;
      .top {
        font-weight: 600;
        font-size: 13px;
        color: #4a4a4a;
        line-height: 18px;
        text-align: left;
      }
      .content {
        display: flex;
        justify-content: space-between;
        font-weight: 400;
        font-size: 13px;
        color: #999999;
        line-height: 18px;
        text-align: left;
        margin-top: 10px;
        .openPrice {
          display: flex;
          line-height: 34px;
          .price {
            position: relative;
            font-weight: 600;
            font-size: 24px;
            color: #ff4747;
            line-height: 33px;
            text-align: left;
            margin-left: 5px;
            .el-icon-top {
              position: absolute;
              right: -22px;
              top: 6px;
              font-weight: 800;
              font-size: 22px;
            }
            .el-icon-bottom {
              position: absolute;
              right: -22px;
              top: 6px;
              font-weight: 800;
              font-size: 22px;
            }
            .el-icon-plus {
              position: absolute;
              font-size: 7px;
              font-weight: 1000;
            }
          }
        }
        .closePrice {
          display: flex;
          line-height: 34px;
          .price {
            position: relative;
            font-weight: 600;
            font-size: 13px;
            color: #2ba571;
            line-height: 33px;
            text-align: left;
            margin-left: 5px;
          }
        }
      }
      .bottom {
        display: flex;
        justify-content: space-between;
        margin-top: 7px;
        .address {
          font-weight: 400;
          font-size: 12px;
          color: #4a4a4a;
          line-height: 17px;
          text-align: left;
        }
        .time {
          font-weight: 400;
          font-size: 12px;
          color: #999999;
          line-height: 17px;
          text-align: left;
        }
      }
    }
  }
  .location-select {
    position: absolute;
    top: 16px;
    right: 7%;
    font-weight: 500;
    font-size: 13px;
    color: #4a4a4a;
    line-height: 18px;
    /deep/ .el-select {
      width: 72px !important;
    }
    /deep/ .el-input--suffix .el-input__inner {
      padding: 0 !important;
      text-align: right;
      padding-right: 18px !important;
      border: none !important;
    }
  }
  /deep/ .el-tabs__header {
    margin-bottom: 16px;
  }
  .notice-more {
    position: absolute;
    top: 17px;
    right: 20px;
    line-height: 30px;
    &:hover {
      color: #0089ef;
    }
  }
}
/deep/.el-tabs__nav-wrap {
  padding-top: 3px;
  padding-right: 60px;
  width: 77%;
  left: 10%;
}
/deep/ .el-tabs__active-bar {
  display: none;
}

/deep/ .el-tabs__nav-prev {
  line-height: 24px;
}

/deep/ .el-tabs__nav-next {
  line-height: 24px;
  right: 40px;
}
/deep/ .el-tabs__item {
  padding: 0;
  font-size: 16px;
  font-weight: 600;
  color: #4a4a4a;
  text-align: center;
  margin-right: 10px;
  min-width: 88px;
  height: 36px;
  line-height: 36px;
  border-radius: 16px;
  box-sizing: content-box;
}
/deep/ .is-active {
  color: #ffffff;
}

/deep/ .el-tabs__item:hover {
  color: #0089ef;
  background: rgba(0, 137, 239, 0.06);
  border: 1px solid #0089ef;
  border-radius: 16px;
}
/deep/ .el-tabs__item.is-active {
  color: #ffffff;
  background: #0089ef;
  border-radius: 16px;
  border: none;
  border: 1px solid #0089ef;
}
/deep/.el-date-editor .el-range-separator {
  font-size: 13px;
}
.el-range-editor.el-input__inner {
  border: none;
  padding-top: 5px;
}
.dropdown {
  position: relative;
  display: inline-block;
}
.price-guidance .location-select .typeselect {
  width: 75px !important;
}
.price-guidance .location-select .matselect {
  width: 150px !important;
}
.el-date-editor.el-input__inner.el-date-editor--daterange {
  padding-left: 0;
}
</style>
